import React, { Fragment, Component } from "react";
import '../../scss/_step.scss';

export default class StepToShowComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { steps, currentPage } = this.props;
        return (
            <Fragment>
                <div className="step-wrapper justify-content-center">
                    <div className="position-relative d-flex">
                        <div className="line"></div>
                        {
                            steps && 
                            steps.map((step, i) => {
                                return <StepItem key={i} detail={step} page={currentPage} />
                            })
                        }
                    </div>
                </div>
            </Fragment>
        )
    }
}

const StepItem = (props) => {
    const { detail, page } = props;
    const isActive = page === detail.value;
    const previosStep = page > detail.value;
    return <div className={ `item-wrapper d-flex flex-column ${page === detail.value ? 'active' : previosStep ? 'previous' : ''}` }>
        <Dot isActive={isActive} page={page} />
        <p className="step-name">{detail.name}</p>
    </div>
}

const Dot = (props) => {
    const { page, isActive } = props;
    return <div className={ `oval mt-auto mb-auto ${isActive? 'active' : ''}` }>
        {
            isActive && <span className="page-text">{page}</span>
        }
    </div>
}